import Link from 'next/link';
import { ReactNode } from 'react';

interface LinkProps {
  href: string;
  children: ReactNode;
}

export type LinkType = 'internal' | 'external' | 'download';

export const InternalLink = ({ href, children }: LinkProps) => <Link href={href}>{children}</Link>;

export const ExternalLink = ({ href, children }: LinkProps) => (
  <a href={href} target="_blank" rel="noopener noreferrer">
    {children}
  </a>
);

export const DownloadLink = ({ href, children }: LinkProps) => (
  <a href={href} download>
    {children}
  </a>
);

const linkComponents = {
  internal: InternalLink,
  external: ExternalLink,
  download: DownloadLink,
};

interface AdaptiveLinkProps extends LinkProps {
  type: LinkType;
}

const PcAdaptiveLink = ({ type, href, children }: AdaptiveLinkProps) => {
  const Component = linkComponents[type] || InternalLink;
  return <Component href={href}>{children}</Component>;
};

export default PcAdaptiveLink;
